import z from "zod";
import { teamCapabilities } from "../../../organizations";

/**
 * The two picker values that are not team ids. `all` is the absence of a filter and never has to
 * reach the server; `unassigned` does, because "belongs to no team" is a predicate only the
 * database can answer.
 */
export const TEAM_FILTER_ALL = "all";
export const TEAM_FILTER_UNASSIGNED = "unassigned";

export const getOrganizationMembersQuerySchema = z.object({
	capabilities: z.preprocess((val) => {
		if (Array.isArray(val)) return val;
		if (typeof val === "string") return [val];
	}, z.array(z.enum(teamCapabilities)).optional()),
	/**
	 * "Every team" reaches the server as the literal string "null", as an empty value or as
	 * `TEAM_FILTER_ALL`, because the picker keeps its state in the query string and a caller may
	 * forward that value unchanged. All three mean "do not filter". `TEAM_FILTER_UNASSIGNED` is
	 * the opposite of them: it narrows the list to the members no team of the caller's
	 * organisation holds.
	 */
	teamId: z.preprocess(
		(val) => (val === "null" || val === "" || val === TEAM_FILTER_ALL ? undefined : val),
		z.union([z.uuid(), z.literal(TEAM_FILTER_UNASSIGNED)]).optional(),
	),
});

export type GetOrgazationMembersQuerySchema = z.infer<typeof getOrganizationMembersQuerySchema>;
